import { useMemo } from "react";
import { useScores } from "~/sdks/LocalContent/features/useScores";
import { Scores } from "@local-logic/client";

const useFilterSortScores = (category: Partial<keyof Scores["location"]>[]) => {
  const { data, isLoading, isFetching } = useScores(category);

  const cleanScores = useMemo(() => {
    if (isLoading || isFetching || typeof data === "undefined") {
      return [];
    }

    const dataKeys = Object.keys(data.location);

    const filteredLocationKeys = dataKeys
      .filter(
        (score) =>
          Number.parseFloat(
            data?.location[score as keyof Scores["location"]].value
          ).toFixed(1) !== "0.0"
      )
      .map((score) => ({
        score,
        value: Number.parseFloat(
          data?.location[score as keyof Scores["location"]].value
        ).toFixed(1),
      }))
      .sort((a, b) => (a.value < b.value ? 1 : -1));

    if (filteredLocationKeys.length > 0) {
      const foundScores = filteredLocationKeys.map(
        (score) => score.score as keyof Scores["location"]
      );

      return foundScores;
    }

    return [];
  }, [data, isLoading, isFetching]);

  return { cleanScores, data, isLoading, isFetching };
};

export default useFilterSortScores;
